/*
    * Trigger Animations on Viewport just give class action-animationstyle-timeout to element
    */
    
jQuery(function($) {
    
    var waypointAnimation = function() {

        var action = $('[class^=action]');

        action.waypoint(function (direction) {
            var element = $(this);
            var elementclasses = element.attr('class');

            var elementclass = elementclasses.substr(elementclasses.indexOf('action-') + 5);
            elementclass = elementclass.substr(0, elementclass.indexOf(' '));

            var toDelete = elementclasses.substr(elementclasses.indexOf('action-'));
            toDelete = toDelete.substr(0, toDelete.indexOf(' '));

            var animaitonClass = elementclass.substr(elementclass.indexOf('-') + 1);
            var timeout = animaitonClass.substr(animaitonClass.indexOf('-') + 1);


            if (direction == 'down') {
                if (animaitonClass != timeout) {
                    animaitonClass = animaitonClass.substr(0, animaitonClass.indexOf('-'));
                } else {
                    timeout = 100;
                }
                // console.log('Animationclass: ' + animaitonClass + ', Timeout: ' + timeout);

                setTimeout(function () {
                    element.removeClass(toDelete);
                    element.addClass('animated ' + animaitonClass);
                }, timeout);
            }
        }, {
            offset: '95%'
        });


        var strike = $('[class=strike]');
        strike.waypoint(function (direction) {
        // $('[class=strike]').waypoint(function (direction) {
            // var element = $(this);
            $(this).addClass('strikethrough');
        }, {
            offset: '70%'
        });

    };

waypointAnimation();

});


